<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icon/General/ErrorV2">
      <path
        id="Error_icon"
        d="M12 21.5C7.02944 21.5 3 17.4706 3 12.5C3 7.52944 7.02944 3.5 12 3.5C16.9706 3.5 21 7.52944 21 12.5C20.9945 17.4683 16.9683 21.4945 12 21.5ZM12 15.2C11.5029 15.2 11.1 15.6029 11.1 16.1C11.1 16.5971 11.5029 17 12 17C12.4971 17 12.9 16.5971 12.9 16.1C12.9 15.6029 12.4971 15.2 12 15.2ZM12 8C11.5029 8 11.1 8.40294 11.1 8.9V12.5C11.1 12.9971 11.5029 13.4 12 13.4C12.4971 13.4 12.9 12.9971 12.9 12.5V8.9C12.9 8.40294 12.4971 8 12 8Z"
        fill="#FF726D"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'GeneralErrorIconV2'
}
</script>
